// extracted by mini-css-extract-plugin
export var heading = "SectionSpotlightDogs-module--heading--d1894";
export var introtext = "SectionSpotlightDogs-module--introtext--3c71a";
export var showalldogs = "SectionSpotlightDogs-module--showalldogs--037c5";
export var spotlightdogsinner = "SectionSpotlightDogs-module--spotlightdogsinner--df15d";
export var title = "SectionSpotlightDogs-module--title--b3924";